import type { ChatStatus } from './types';

export const CHAT_STATUS = {
  READY: 'ready',
  SUBMITTED: 'submitted',
  STREAMING: 'streaming',
  ERROR: 'error',
} as const satisfies Record<string, ChatStatus>;

export const ChatStatusHelpers = {
  isReady: (status: ChatStatus): boolean => status === CHAT_STATUS.READY,
  isSubmitted: (status: ChatStatus): boolean =>
    status === CHAT_STATUS.SUBMITTED,
  isStreaming: (status: ChatStatus): boolean =>
    status === CHAT_STATUS.STREAMING,
  isError: (status: ChatStatus): boolean => status === CHAT_STATUS.ERROR,
  isProcessing: (status: ChatStatus): boolean =>
    status === CHAT_STATUS.SUBMITTED || status === CHAT_STATUS.STREAMING,
  isBusy: (status: ChatStatus): boolean =>
    status === CHAT_STATUS.SUBMITTED || status === CHAT_STATUS.STREAMING,
  canSubmit: (status: ChatStatus): boolean => status === CHAT_STATUS.READY,
} as const;

/**
 * Longest message the composer will send. Frontend only for now: the chat
 * backend accepts any length, so this is the single number to share with it.
 */
export const CHAT_INPUT_MAX_LENGTH = 4000;

/** Share of the limit at which the composer starts showing the count. */
export const CHAT_INPUT_COUNT_THRESHOLD = 0.9;

/**
 * The composer's footer icons and send arrow, in Phosphor's light weight
 * (Chat UI Clean, Figma 1101:3985 and 1101:3991).
 */
export const CHAT_INPUT_ICON_SIZE = 24;
